import { combineEpics } from 'redux-observable'
import { createInvokeEpic } from '../../signalr/createInvokeEpic'
import { confirmOrderDefinition, rejectOrderDefinition } from './definition'

export default combineEpics(
  createInvokeEpic('lastLook.rejectOrder', rejectOrderDefinition),
  createInvokeEpic('lastLook.confirmOrder', confirmOrderDefinition)
)
